var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-flex uk-flex-column uk-flex-middle"},[_c('div',{staticClass:"uk-width-1-2 uk-width-1-3@m uk-text-center"},[_c('h1',[_vm._v(" "+_vm._s(_vm.status)+" ")]),_c('p',[_vm._v(_vm._s(_vm.messageI18N))])])])}
var staticRenderFns = []

export { render, staticRenderFns }